module.exports = __webpack_public_path__ + "media/images/favicon-9901ca8aaa549be4e84721c59cff95f4.ico";